import React from "react";
import Header from "../../components/Header/Header";
import Sidebar from "./components/Sidebar/Sidebar";
import RequestList from "./RequestList/RequestList";
import Request from "./RequestDetailsPage/Request";
import ProfileModal from "./components/Modals/ProfileModal";
import Account from "./Account/AccountPage";
import BillingPage from "./Billing/BillingPage";
import InsightsPage from "./Insights/InsightsPage";
import TeamsPage from "./TeamMembers/TeamsPage";
import CallScriptsPage from "./CallScripts/CallScriptsPage";
import VerificationsPage from "./Verifications/VerificationsPage";
import PatientCallsPage from "./PatientCalls/PatientCallsPage";
import InboundCallsPage from "./InboundCalls/InboundCallsPage";
import InboundCallDetail from "./InboundCalls/InboundCallDetail";
import KnowledgeBankPage from "./InboundCalls/KnowledgeBankPage";
import AppointmentTypesPage from "./AppointmentTypes/AppointmentTypesPage";
import ClearCachePage from "./ClearCache/ClearCachePage";
import BackButton from "components/ui/back-button";
import NewRequestPage from "./NewRequestPage/NewRequestPage";
import { useState, useEffect, useCallback } from "react";
// @ts-ignore
import { useIdle } from "@uidotdev/usehooks";
import baseApi from "utils/axios-instance";
import { useNavigate, useParams, useSearchParams, useLocation } from "react-router-dom";
import {
  IDLE_MS,
  DASHBOARD_UPDATE_POLLING_FREQUENCY_MS,
} from "utils/constants";
import { DEBUG_EMAILS } from "utils/constants";
import { Mixpanel } from "utils/Analytics";
import { useDispatch, useSelector } from "react-redux";
import {
  Practice,
  ProfileInfo,
  Provider,
  UserTransferPhoneNumber,
} from "../../utils/ProfileInfo";
import {
  INBOX,
  REQUEST,
  ACCOUNT,
  BILLING,
  INSIGHTS,
  TEAM_MEMBERS,
  CALL_SCRIPTS,
  VERIFICATIONS,
  PATIENT_CALLS,
  NEW_REQUEST_PAGE,
  PROFILEMODAL,
} from "utils/reducers";
import fetchRequest from "store/thunks/fetchRequest";
import { X, Loader2 } from "lucide-react";
import ErrorBoundary from "components/ui/error-boundary";

function MVP() {
  const showProfileModal = useSelector((state: any) => state.profileModal.show);
  const showAccount = useSelector((state: any) => state.showAccount.show);
  const showBilling = useSelector((state: any) => state.showBilling.show);
  const showInsights = useSelector((state: any) => state.showInsights.show);
  const showTeamMembers = useSelector((state: any) => state.showTeamMembers.show);
  const showCallScripts = useSelector((state: any) => state.showCallScripts.show);
  const showVerifications = useSelector((state: any) => state.showVerifications.show);
  const showPatientCalls = useSelector((state: any) => state.showPatientCalls.show);
  const showRequest = useSelector((state: any) => state.showRequest.show);
  const showNewRequestPage = useSelector(
    (state: any) => state.showNewRequestPage.show
  );

  const [loading, setLoading] = useState(true);
  const [inboxCount, setInboxCount] = useState(0);
  const [currentUser, setCurrentUser] = useState({
    email: "",
    debug: false,
    first_name: "",
    last_name: "",
    picture_url: "",
    id: "",
    team_id: "",
  });
  const [isTeamInbox, setIsTeamInbox] = useState(false);
  const [requestRows, setRequestRows] = useState([]);
  const [debugUser, setDebugUser] = useState(false);
  const [profileInfo, setProfileInfo] = useState<ProfileInfo>();
  const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  // Deeplink functionality to the underlying request page.
  const { inquiryId } = useParams();
  const location = useLocation();
  const isBillingRoute = location.pathname === "/dashboard/billing";
  const isPatientCallsRoute = location.pathname === "/dashboard/patient-calls";
  const isInsightsRoute = location.pathname === "/dashboard/insights";
  const isTeamMembersRoute = location.pathname === "/dashboard/team-members";
  const isCallScriptsRoute = location.pathname === "/dashboard/call-scripts";
  const isVerificationsRoute = location.pathname === "/dashboard/verifications";
  const isInboundCallsRoute = location.pathname.startsWith(
    "/dashboard/inbound-calls"
  );
  const isInboundCallDetailRoute = location.pathname.startsWith(
    "/dashboard/inbound-calls/calls/"
  );
  const isKnowledgeBankRoute =
    location.pathname === "/dashboard/inbound-calls/knowledge-bank";
  const isAppointmentTypesRoute =
    location.pathname === "/dashboard/inbound-calls/appointment-types";
  const isClearCacheRoute = location.pathname === "/dashboard/clear-cache";
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (isBillingRoute) {
      dispatch({ type: BILLING.display });
      dispatch({ type: PATIENT_CALLS.hide });
      dispatch({ type: INSIGHTS.hide });
      dispatch({ type: TEAM_MEMBERS.hide });
      dispatch({ type: CALL_SCRIPTS.hide });
      dispatch({ type: VERIFICATIONS.hide });
      dispatch({ type: REQUEST.hide });
      dispatch({ type: ACCOUNT.hide });
      dispatch({ type: NEW_REQUEST_PAGE.hide });
      return;
    }
    if (isPatientCallsRoute) {
      dispatch({ type: PATIENT_CALLS.display });
      dispatch({ type: BILLING.hide });
      dispatch({ type: INSIGHTS.hide });
      dispatch({ type: TEAM_MEMBERS.hide });
      dispatch({ type: CALL_SCRIPTS.hide });
      dispatch({ type: VERIFICATIONS.hide });
      dispatch({ type: REQUEST.hide });
      dispatch({ type: ACCOUNT.hide });
      dispatch({ type: NEW_REQUEST_PAGE.hide });
      return;
    }
    if (isInsightsRoute) {
      dispatch({ type: INSIGHTS.display });
      dispatch({ type: BILLING.hide });
      dispatch({ type: PATIENT_CALLS.hide });
      dispatch({ type: TEAM_MEMBERS.hide });
      dispatch({ type: CALL_SCRIPTS.hide });
      dispatch({ type: VERIFICATIONS.hide });
      dispatch({ type: REQUEST.hide });
      dispatch({ type: ACCOUNT.hide });
      dispatch({ type: NEW_REQUEST_PAGE.hide });
      return;
    }
    if (isTeamMembersRoute) {
      dispatch({ type: TEAM_MEMBERS.display });
      dispatch({ type: BILLING.hide });
      dispatch({ type: PATIENT_CALLS.hide });
      dispatch({ type: INSIGHTS.hide });
      dispatch({ type: CALL_SCRIPTS.hide });
      dispatch({ type: VERIFICATIONS.hide });
      dispatch({ type: REQUEST.hide });
      dispatch({ type: ACCOUNT.hide });
      dispatch({ type: NEW_REQUEST_PAGE.hide });
      return;
    }
    if (isCallScriptsRoute) {
      dispatch({ type: CALL_SCRIPTS.display });
      dispatch({ type: BILLING.hide });
      dispatch({ type: PATIENT_CALLS.hide });
      dispatch({ type: INSIGHTS.hide });
      dispatch({ type: TEAM_MEMBERS.hide });
      dispatch({ type: VERIFICATIONS.hide });
      dispatch({ type: REQUEST.hide });
      dispatch({ type: ACCOUNT.hide });
      dispatch({ type: NEW_REQUEST_PAGE.hide });
      return;
    }
    if (isVerificationsRoute) {
      dispatch({ type: VERIFICATIONS.display });
      dispatch({ type: BILLING.hide });
      dispatch({ type: PATIENT_CALLS.hide });
      dispatch({ type: INSIGHTS.hide });
      dispatch({ type: TEAM_MEMBERS.hide });
      dispatch({ type: CALL_SCRIPTS.hide });
      dispatch({ type: REQUEST.hide });
      dispatch({ type: ACCOUNT.hide });
      dispatch({ type: NEW_REQUEST_PAGE.hide });
      return;
    }
    if (isClearCacheRoute) {
      dispatch({ type: BILLING.hide });
      dispatch({ type: PATIENT_CALLS.hide });
      dispatch({ type: INSIGHTS.hide });
      dispatch({ type: TEAM_MEMBERS.hide });
      dispatch({ type: CALL_SCRIPTS.hide });
      dispatch({ type: VERIFICATIONS.hide });
      dispatch({ type: REQUEST.hide });
      dispatch({ type: ACCOUNT.hide });
      dispatch({ type: NEW_REQUEST_PAGE.hide });
      return;
    }
    dispatch({ type: BILLING.hide });
    dispatch({ type: PATIENT_CALLS.hide });
    dispatch({ type: INSIGHTS.hide });
    dispatch({ type: TEAM_MEMBERS.hide });
    dispatch({ type: CALL_SCRIPTS.hide });
    dispatch({ type: VERIFICATIONS.hide });
  }, [
    isBillingRoute,
    isPatientCallsRoute,
    isInsightsRoute,
    isTeamMembersRoute,
    isCallScriptsRoute,
    isVerificationsRoute,
    isClearCacheRoute,
    dispatch,
  ]);

  useEffect(() => {
    if (
      inquiryId !== undefined &&
      !isBillingRoute &&
      !isPatientCallsRoute &&
      !isInsightsRoute &&
      !isTeamMembersRoute &&
      !isCallScriptsRoute &&
      !isVerificationsRoute &&
      !isInboundCallsRoute &&
      !isClearCacheRoute
    ) {
      dispatch({ type: REQUEST.display });
      dispatch(fetchRequest(inquiryId) as any);
    }
  }, [
    dispatch,
    inquiryId,
    isBillingRoute,
    isPatientCallsRoute,
    isInsightsRoute,
    isTeamMembersRoute,
    isCallScriptsRoute,
    isVerificationsRoute,
    isInboundCallsRoute,
    isClearCacheRoute,
  ]);

  // Handle provider_saved parameter from OAuth callback
  useEffect(() => {
    const providerSaved = searchParams.get("provider_saved");
    if (providerSaved === "google" || providerSaved === "microsoft") {
      localStorage.setItem("preferred_login_provider", providerSaved);
      // Remove the parameter from URL
      searchParams.delete("provider_saved");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const navigate = useNavigate();

  // The Inbound Calls page is a non-functional UI mock, so it stays limited to
  // debug users until it is backed by a real implementation.
  const inboundCallsEnabled = debugUser;

  // Send non-enabled users back to the inbox if they open an inbound-calls URL.
  useEffect(() => {
    if (
      isInboundCallsRoute &&
      currentUser.id !== "" &&
      !inboundCallsEnabled
    ) {
      navigate("/dashboard", { replace: true });
    }
  }, [isInboundCallsRoute, currentUser.id, inboundCallsEnabled, navigate]);

  // Helper function to handle authentication errors consistently
  const handleAuthError = useCallback(
    (error: any) => {
      // Handle explicit HTTP auth errors from the backend
      if (error.response?.status === 401 || error.response?.status === 303) {
        navigate("/logged-out", { replace: true });
        return true;
      }

      // Handle network errors that are likely caused by a CORS block
      // on an auth redirect. This is less reliable but necessary when the
      // backend redirects API calls to an external login page.
      if (!error.response && error.code === "ERR_NETWORK") {
        navigate("/logged-out", { replace: true });
        return true;
      }

      return false;
    },
    [navigate]
  );

  const logout = useCallback((isManual: boolean = false) => {
    // Clear localStorage preference only on manual logout
    if (isManual) {
      localStorage.removeItem("preferred_login_provider");
    }
    baseApi
      .get("/logout")
      .then((response) => {
        window.location.replace("/"); // Full page reload
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const idle = useIdle(IDLE_MS);

  // Logout when idle.
  useEffect(() => {
    if (currentUser.id === "") {
      return;
    }
    if (idle) {
      if (debugUser) {
        console.log("Debug user detected. Bypassing idle logout.");
        return;
      }
      Mixpanel.track("Idle Logout", currentUser);
      logout(false); // Idle logout - don't clear localStorage preference
    }
  }, [idle, currentUser, debugUser, logout]);

  const reloadPage = useCallback(
    async (showLoadingOverlay: boolean = true, inboxType?: string) => {
      if (showLoadingOverlay) {
        setLoading(true);
      }

      let dataRoute = "";
      const targetInboxType =
        inboxType ||
        (isTeamInbox ? INBOX.team_inbox : INBOX.current_user_inbox);

      if (targetInboxType === INBOX.current_user_inbox)
        dataRoute = "/dashboard/data/current_user";
      if (targetInboxType === INBOX.team_inbox) dataRoute = "/dashboard/data";

      try {
        const response = await baseApi.get(dataRoute, {
          withCredentials: true,
        });
        if (JSON.stringify(requestRows) !== JSON.stringify(response.data)) {
          setRequestRows(response.data);
          setInboxCount(response.data.length);
        }
      } catch (error) {
        if (handleAuthError(error)) return;
        console.log(error);
        Mixpanel.track("Error: Reload Page", { error: error });
      } finally {
        if (showLoadingOverlay) {
          setLoading(false);
        }
      }
    },
    [handleAuthError, isTeamInbox, requestRows]
  );

  const refreshProfileInfo = useCallback(() => {
    return baseApi
      .get("/profile")
      .then((response) => {
        // TODO(alan): Verification of result from backend
        var practices: Array<Practice> = [];
        for (const practice of response.data.practices) {
          var providers: Array<Provider> = [];
          for (const provider of practice.providers) {
            providers.push({
              name: provider.name,
              npi: provider.npi,
              id: provider.id,
            });
          }
          practices.push({
            name: practice.name,
            tax_id: practice.tax_id,
            providers: providers,
            address: practice.address,
            city: practice.city,
            state: practice.state,
            zip: practice.zip,
            id: practice.id,
          });
        }
        var user_transfer_phone_numbers: Array<UserTransferPhoneNumber> = [];
        for (const phone_number of response.data.phone_numbers) {
          user_transfer_phone_numbers.push({
            name: phone_number.name,
            phoneNumber: phone_number.phone_number,
          });
        }
        var latest_profile_info: ProfileInfo = {
          specialty: response.data.specialty,
          practices: practices,
          phoneNumbers: user_transfer_phone_numbers,
          is_copilot: response.data.is_copilot,
        };
        setProfileInfo(latest_profile_info);
      })
      .catch((error) => {
        if (handleAuthError(error)) return;
        Mixpanel.track("Error: Retrieving Latest Profile Info", {
          error: error,
        });
        console.log(error);
      });
  }, [handleAuthError]);

  const fetchAllRequests = useCallback(
    (showLoading: boolean = true, isTeamInbox: boolean = false) => {
      if (showLoading) {
        setLoading(true);
      }
      let dataRoute: string = "";
      if (isTeamInbox) {
        dataRoute = "/dashboard/data";
      } else {
        dataRoute = "/dashboard/data/current_user";
      }
      return baseApi
        .get(dataRoute, { withCredentials: true })
        .then((response) => {
          setRequestRows(response.data);
          setInboxCount(response.data.length);
        })
        .catch((error) => {
          if (handleAuthError(error)) return;
          console.log(error);
          Mixpanel.track("Error: Fetch Initial Requests", { error: error });
        })
        .finally(() => {
          if (showLoading) {
            setLoading(false);
          }
        });
    },
    [handleAuthError]
  );

  const searchPatients = useCallback(
    async (query: string) => {
      if (query === "" || query === undefined) {
        setLoading(false);
        setIsSearching(false);
        return;
      }

      setLoading(true);
      setIsSearching(true);
      try {
        const response = await baseApi.get("/dashboard/search", {
          params: { query: query },
          withCredentials: true,
        });

        if (JSON.stringify(requestRows) !== JSON.stringify(response.data)) {
          setRequestRows(response.data);
          setInboxCount(response.data.search_results);
        }
      } catch (error) {
        if (handleAuthError(error)) return;
        console.log(error);
        Mixpanel.track("Error: Search Patients", { error: error });
      } finally {
        setLoading(false);
      }
    },
    [requestRows, handleAuthError]
  );

  const handleClearSearch = useCallback(() => {
    // Reload the normal inbox data when search is cleared
    setIsSearching(false);
    fetchAllRequests(true, isTeamInbox);
  }, [fetchAllRequests, isTeamInbox]);

  //fetch data when inbox is changed
  useEffect(() => {
    fetchAllRequests(true, isTeamInbox);
  }, [isTeamInbox, fetchAllRequests]);

  // Fetch all requests every 5 minutes when not idle, don't show loading indicator for background fetches.
  useEffect(() => {
    if (idle) {
      return;
    }
    const interval = setInterval(() => {
      // Don't show the loading indicator for background fetches
      fetchAllRequests(false, isTeamInbox);
    }, DASHBOARD_UPDATE_POLLING_FREQUENCY_MS); // 5 minutes
    return () => clearInterval(interval);
  }, [idle, fetchAllRequests, isTeamInbox]);

  // On first load, make sure we populate the lastRequest and any profile information (such as specialty, practices and providers.)
  useEffect(() => {
    const fetchInitialData = async () => {
      const userPromise = baseApi
        .get("/dashboard/current-user")
        .then((response) => {
          setCurrentUser({
            email: response.data.email,
            first_name: response.data.first_name,
            last_name: response.data.last_name,
            picture_url: response.data.picture_url,
            id: response.data.id,
            team_id: response.data.team_id,
            debug: response.data.debug || false,
          });

          if (response.data.debug || DEBUG_EMAILS.includes(response.data.email)) {
            setDebugUser(true);
          }
          Mixpanel.identify(response.data.id);
          Mixpanel.people.set({
            $first_name: response.data.first_name,
            $last_name: response.data.last_name,
            $email: response.data.email,
          });
        })
        .catch((error) => {
          if (handleAuthError(error)) return;
          console.log(error);
          Mixpanel.track("Error: Current User", { error: error });
          logout(false); // Error logout - don't clear localStorage preference
        });

      await Promise.all([
        userPromise,
        refreshProfileInfo(),
        fetchAllRequests(),
      ]);
      setLoading(false);
    };
    fetchInitialData();
  }, [logout, navigate, refreshProfileInfo, fetchAllRequests, handleAuthError]);

  // Function to render the main content based on current state
  const renderMainContent = () => {
    if (isInboundCallsRoute) {
      return (
        <div className="flex-1 min-h-0 overflow-y-auto">
          {isAppointmentTypesRoute ? (
            <AppointmentTypesPage />
          ) : isKnowledgeBankRoute ? (
            <KnowledgeBankPage />
          ) : isInboundCallDetailRoute ? (
            <InboundCallDetail />
          ) : (
            <InboundCallsPage />
          )}
        </div>
      );
    }

    if (isClearCacheRoute) {
      return (
        <div className="overflow-y-auto">
          <div className="border-b-2 border-gray-100 px-6 py-2 sticky top-0 bg-white z-10">
            <BackButton
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </div>
          <div className="flex-1 overflow-y-auto">
            <ClearCachePage />
          </div>
        </div>
      );
    }

    if (showBilling || isBillingRoute) {
      return (
        <div className="overflow-y-auto">
          <div className="border-b-2 border-gray-100 px-6 py-2 sticky top-0 bg-white z-10">
            <BackButton
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </div>
          <div className="flex-1 overflow-y-auto">
            <BillingPage />
          </div>
        </div>
      );
    }

    if (showPatientCalls || isPatientCallsRoute) {
      return (
        <div className="overflow-y-auto">
          <div className="border-b-2 border-gray-100 px-6 py-2 sticky top-0 bg-white z-10">
            <BackButton
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </div>
          <div className="flex-1 overflow-y-auto">
            <PatientCallsPage />
          </div>
        </div>
      );
    }

    if (showInsights || isInsightsRoute) {
      return (
        <div className="overflow-y-auto">
          <div className="border-b-2 border-gray-100 px-6 py-2 sticky top-0 bg-white z-10">
            <BackButton
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </div>
          <div className="flex-1 overflow-y-auto">
            <InsightsPage />
          </div>
        </div>
      );
    }

    if (showTeamMembers || isTeamMembersRoute) {
      return (
        <div className="overflow-y-auto">
          <div className="border-b-2 border-gray-100 px-6 py-2 sticky top-0 bg-white z-10">
            <BackButton
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </div>
          <div className="flex-1 overflow-y-auto">
            <TeamsPage />
          </div>
        </div>
      );
    }

    if (showCallScripts || isCallScriptsRoute) {
      return (
        <div className="overflow-y-auto">
          <div className="border-b-2 border-gray-100 px-6 py-2 sticky top-0 bg-white z-10">
            <BackButton
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </div>
          <div className="flex-1 overflow-y-auto">
            <CallScriptsPage />
          </div>
        </div>
      );
    }

    if (showVerifications || isVerificationsRoute) {
      return (
        <div className="overflow-y-auto">
          <div className="border-b-2 border-gray-100 px-6 py-2 sticky top-0 bg-white z-10">
            <BackButton
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </div>
          <div className="flex-1 overflow-y-auto">
            <VerificationsPage />
          </div>
        </div>
      );
    }

    if (showAccount) {
      return (
        <div className="overflow-y-auto">
          <div className="border-b-2 border-gray-100 px-6 py-2 sticky top-0 bg-white z-10">
            <BackButton
              onClick={() => {
                dispatch({ type: ACCOUNT.hide });
              }}
            />
          </div>
          <div className="flex-1 overflow-y-auto">
            <Account refreshProfileInfo={refreshProfileInfo} />
          </div>
        </div>
      );
    }

    if (showNewRequestPage) {
      return (
        <div className="overflow-y-auto">
          <div className="border-b-2 border-gray-100 px-6 py-2 sticky top-0 bg-white z-10">
            <BackButton
              onClick={() => {
                dispatch({ type: NEW_REQUEST_PAGE.hide });
              }}
            />
          </div>
          <div className="flex-1 overflow-y-auto">
            {(() => {
              try {
                // Check if required data is loaded
                if (!profileInfo || !currentUser?.id) {
                  return (
                    <div className="flex items-center justify-center p-8">
                      <Loader2 className="h-6 w-6 animate-spin text-blue-600 mr-2" />
                      <span>Loading form data...</span>
                    </div>
                  );
                }

                return (
                  <NewRequestPage
                    reloadPage={(showLoading = true) => reloadPage(showLoading)}
                    debugUser={debugUser}
                    profileInfo={profileInfo}
                    currentUser={currentUser}
                    refreshProfileInfo={refreshProfileInfo}
                  />
                );
              } catch (error: any) {
                console.error("Error rendering NewRequestPage:", error);
                return (
                  <div>
                    Error loading New Request page: {error?.message || error}
                  </div>
                );
              }
            })()}
          </div>
        </div>
      );
    }

    if (showRequest) {
      return (
        <div className="overflow-y-auto">
          <div className="border-b-2 border-gray-100 px-6 py-2 sticky top-0 bg-white z-10">
            <BackButton
              onClick={() => {
                dispatch({ type: REQUEST.hide });
              }}
            />
          </div>
          <div className="flex-1 overflow-y-auto">
            <Request />
          </div>
        </div>
      );
    }

    // Default to RequestList
    return (
      <div className="overflow-y-auto">
        <RequestList
          inboxCount={inboxCount}
          requestRows={requestRows}
          reloadPage={(showLoading = true) =>
            fetchAllRequests(showLoading, isTeamInbox)
          }
          isTeamInbox={isTeamInbox}
        />
      </div>
    );
  };

  return (
    <ErrorBoundary
      onError={(error, errorInfo) => {
        console.error("MVP Page Error:", error, errorInfo);
        // Track the error for debugging
        if (typeof window !== "undefined" && (window as any).Mixpanel) {
          (window as any).Mixpanel.track("Error: MVP Page Render", {
            error: error.message,
            stack: error.stack,
            componentStack: errorInfo.componentStack,
          });
        }
      }}
    >
      {/* Modals */}
      {showProfileModal && (
        <ProfileModal
          logout={logout}
          currentUser={currentUser}
          onClose={() => dispatch({ type: PROFILEMODAL.hide })}
        />
      )}

      {/* Loading Overlay - Blocks all interactions.
          Inbound Calls is local demo data and must stay scrollable while the
          inbox request list (unrelated) is still fetching. */}
      {loading && !isInboundCallsRoute && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 shadow-xl flex flex-col items-center space-y-4">
            <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
            <p className="text-gray-700 font-medium">Loading...</p>
          </div>
        </div>
      )}

      {/* Main Layout */}
      <div
        className={`flex flex-col h-screen bg-gray-100 font-sans ${loading && !isInboundCallsRoute ? "pointer-events-none opacity-75" : ""
          }`}
      >
        {/* Header */}
        <div className="flex-shrink-0">
          <Header
            currentUser={currentUser}
            noSearch={showAccount || showBilling || showPatientCalls || showInsights || showTeamMembers || showCallScripts || showVerifications || showRequest || showNewRequestPage || isInboundCallsRoute || isClearCacheRoute}
            onMenuClick={() => setMobileSidebarOpen(true)}
            searchPatients={searchPatients}
            onClearSearch={handleClearSearch}
          />
        </div>

        {/* Page Body */}
        <div className="flex flex-1 overflow-hidden">
          {/* Mobile Sidebar */}
          {isMobileSidebarOpen && (
            <div className="md:hidden fixed inset-0 flex z-40">
              {/* Overlay */}
              <div
                className="fixed inset-0"
                onClick={() => setMobileSidebarOpen(false)}
              >
                <div className="absolute inset-0 bg-gray-600 opacity-75"></div>
              </div>

              {/* Sidebar Panel */}
              <div className="relative flex-1 flex flex-col max-w-xs w-full bg-white">
                <div className="absolute top-0 right-0 -mr-12 pt-2">
                  <button
                    onClick={() => setMobileSidebarOpen(false)}
                    className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                  >
                    <span className="sr-only">Close sidebar</span>
                    <X className="h-6 w-6 text-white" />
                  </button>
                </div>
                <Sidebar
                  inboxCount={inboxCount}
                  isTeamInbox={isTeamInbox}
                  setIsTeamInbox={setIsTeamInbox}
                  isSearching={isSearching}
                  setIsSearching={setIsSearching}
                  showInboundCalls={inboundCallsEnabled}
                />
              </div>
              <div className="flex-shrink-0 w-14" aria-hidden="true">
                {/* Dummy element to force sidebar to shrink to fit close icon */}
              </div>
            </div>
          )}

          {/* Desktop Sidebar */}
          <div className="hidden md:flex md:w-64 md:flex-shrink-0">
            <div className="flex flex-col w-64">
              <Sidebar
                inboxCount={inboxCount}
                isTeamInbox={isTeamInbox}
                setIsTeamInbox={setIsTeamInbox}
                isSearching={isSearching}
                setIsSearching={setIsSearching}
                showInboundCalls={inboundCallsEnabled}
              />
            </div>
          </div>

          {/* Main Content Area */}
          <main className="flex-1 min-h-0 overflow-hidden bg-white rounded-xl shadow-sm border border-gray-100 flex flex-col m-2 mt-0">
            {renderMainContent()}
          </main>
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default MVP;
